define('models/pages/favorites/goodsItem',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var GoodsItem = Model.extend({
        urlPath: function() {
            var id = this.get('id');
            return '/favorite-goods' + (id ? ('/' + id) : '');
        },
        defaults: {
            countryName: '',
            type: '',
            sort: ''
        },
        constructor: function(data) {
            if(data){
                data.isFavorite = data.isFavorite + '';
                data.searchString = (data.type ? data.type.toLowerCase() : '') + ' ' + (data.countryName ? data.countryName.toLowerCase() : '') + ' ' + (data.sort ? data.sort.toLowerCase() : '');
            }
            Model.apply(this, arguments);
        }
    });

    return GoodsItem;
});
